import Flickity from 'flickity'
import 'flickity-as-nav-for';


document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('.product-img-gallery')) {
        new Flickity(document.querySelector('.product-img-gallery'), {
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            cellSelector: '.product-img-gallery__cell'
        })

        new Flickity(document.querySelector('.product-img-navigation'), {
            asNavFor: '.product-img-gallery',
            cellSelector: '.product-img-navigation__cell',
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            prevNextButtons: false,
        })
    }

    if (document.querySelector('.recommended-products__slider')) {
        new Flickity(document.querySelector('.recommended-products__slider'), {
            cellAlign: 'left',
            contain: true,
            wrapAround: true,
            pageDots: false,
            prevNextButtons: false,
            cellSelector: '.recommended-products__product'
        })
    }
})